<template>
  <template v-if="$page">
    <div class="section -less-pad">
      <h1 class="section__header">{{ $page.title }}</h1>
      <div v-html="$page.content" class="wysiwyg" />
    </div>
  </template>

  <template v-else>
    <Loader />
  </template>
</template>

<script>
import Loader from '@/App.vue'
import { setMeta } from '@/helpers/metaHelpers'

export default {
  name: 'Conditions',
  components: { Loader },
  beetPage: 'conditions',
  watch: {
    $page(to) {
      setMeta(to.seo)
    },
  },
  beforeMount() {
    if (this.$page) setMeta(this.$page.seo)
  },
}
</script>
